import setToUtc from "./setToUtc";

export default function (dateInput: Date, isEqual: boolean = false): boolean {
  const today = new Date();
  const date = setToUtc(new Date(dateInput));
  today.setHours(0, 0, 0, 0); // Set the time to 00:00:00.000
  date.setHours(0, 0, 0, 0); // Set the time to 00:00:00.000

  return isEqual ? date <= today : date < today;
}
